

const BARS = "bars"
const CUSTOMERS = "customers"
const INVENTORY = "inventory"
const POINTS = "points"
const REWARDS = "rewards"
const PAYMENT_RECIPTS = "receipts"


const bars = () => BARS;
const bar = (id: string) => `${BARS}/${id}`;
const customers = () => CUSTOMERS;
const customer = (id: string) => `${CUSTOMERS}/${id}`;
const inventoryItems = (barId: string) => `${bar(barId)}/${INVENTORY}`
const inventoryItem = (barId: string, id: string) => `${inventoryItems(barId)}/${id}`
const points = () => POINTS
const point = (id: string) => `${points()}/${id}`
const rewards = () => REWARDS
const payment_recipts = () => PAYMENT_RECIPTS







const DB_COLLECTIONS = {
   bars,
   bar,
   customers,
   customer,
   inventoryItems,
   inventoryItem,
   point,
   points,
   rewards,
   payment_recipts
}

export default DB_COLLECTIONS